import React from "react";
import { Box, Button, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import styled from "@emotion/styled";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { DatePicker } from "@mui/x-date-pickers";
import { InputAdornment, IconButton } from "@mui/material";
import { Check } from "@mui/icons-material";
import dayjs from "dayjs";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  formatNumber,
  maskedAccountId,
  maskAccountNumber,
  maskSSNNumber,
} from "../common/Utils";
import SearchAllowanceModal from "./SearchAllowanceModal";
import AllowanceModal from "./AllowanceModal";
import SSNTextField from "../common/SSNTextField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

let k = "";
let p = "";
let r = "";
let s = "";
let y = "";
var today_date = new Date();
k = today_date.getMonth() + 1;
if (today_date.getMonth() + 1 < 10) {
  p = today_date.getMonth() + 1;
  k = "0" + p;
}
s = today_date.getDate();
if (today_date.getDate() < 10) {
  r = today_date.getDate();
  s = "0" + r;
}
y = today_date.getFullYear();
var today_date = k + "/" + s + "/" + y;

export default function AllowanceUpdateForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const carefacilitydetails = useSelector((state) => state.carefacilitydetails);
  const [open, setOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [allowanceModalOpen, setAllowanceModalOpen] = React.useState(false);
  const [searchmodalopen, setsearchmodalOpen] = React.useState(false);
  const [snackbardata, setsnackbardata] = useState(false);
  const [indicatordata, setindicatordata] = useState(false);
  const [showSSN, setShowSSN] = useState(false);
  const [hasFocus, setFocus] = useState(false);
  const [nameRowHeight, setRowHeight] = useState("65px");
  const [ssnRowHeight, setSSNHeight] = useState("65px");
  const [allowanceHeight, setAllowanceHeight] = useState("65px");
  const [achEDate, setAchEDate] = React.useState("");
  const [showMsg, setShowMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successFlag, setSuccessFlag] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [msgModalOpen, setMsgModalOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [formErrors, setFormErrors] = useState({
    firstName: "",
    err_firstName: false,
    lastName: "",
    err_lastName: false,
    SSN: "",
    err_SSN: false,
    allowance: "",
    err_allowance: false,
  });

  const [allowanceFields, setAllowanceFields] = useState({
    firstName: "",
    lastName: "",
    SSN: "",
    accountNum: "",
    mask_accNum: "",
    address: {
      street: "",
      city: "",
      state: "",
      zip_code: "",
    },
    tele_number: "",
    contact: "",
    repre_payee: "",
    acc_type: "",
    enroll_date: today_date,
    picker_date: new Date(),
    medi: "",
    resiID: "",
    allowance: "",
    enrollmentId: "",
  });

  useEffect(() => {
    setCarefacilitydefaultVals();
  }, [carefacilitydetails]);

  useEffect(() => {
    setTimeout(() => {
      setsnackbardata(false);
    }, 5000);
  }, [snackbardata]);

  const BackButton = styled(Button)({
    borderColor: "#002d82",
    border: "2px solid",
    color: "#002d82",
    borderRadius: "5px",
  });

  const ResetButton = styled(Button)({
    borderColor: "#e81313",
    border: "2px solid",
    color: "#e81313",
    borderRadius: "5px",
  });

  const setCarefacilitydefaultVals = () => {
    setAllowanceFields({
      ...allowanceFields,
      contact: carefacilitydetails.contactPerson,
      tele_number: carefacilitydetails.phone,
      mask_accNum: maskedAccountId(carefacilitydetails.accountNumber),
      accountNum: carefacilitydetails.accountNumber,
      address: {
        street: carefacilitydetails.address,
        city: carefacilitydetails.city,
        state: carefacilitydetails.state,
        zip_code: carefacilitydetails.zip,
      },
      allowance_date: achEDate,
    });
  };

  const inputHandler = (e) => {
    e.preventDefault();
    if (e.target.name === "add_street") {
      setAllowanceFields({
        ...allowanceFields,
        address: { ...allowanceFields.address, street: e.target.value },
      });
    } else if (e.target.name === "add_city") {
      setAllowanceFields({
        ...allowanceFields,
        address: { ...allowanceFields.address, city: e.target.value },
      });
    } else if (e.target.name === "add_state") {
      setAllowanceFields({
        ...allowanceFields,
        address: {
          ...allowanceFields.address,
          state: e.target.value.toUpperCase(),
        },
      });
    } else if (e.target.name === "add_code") {
      const regex = /^[0-9]+$/;
      if (regex.test(e.target.value)) {
        setAllowanceFields({
          ...allowanceFields,
          address: { ...allowanceFields.address, zip_code: e.target.value },
        });
      } else {
        setAllowanceFields({
          ...allowanceFields,
          address: { ...allowanceFields.address, zip_code: "" },
        });
      }
    } else if (e.target.name === "accountNum") {
      let accNumVal = allowanceFields.accountNum;
      const value = e.target.value;
      const valueLen = value.length;
      accNumVal = accNumVal + value[valueLen - 1];
      const accountId = maskAccountNumber(e.target.value);
      setAllowanceFields({
        ...allowanceFields,
        mask_accNum: accountId,
        accountNum: accNumVal,
      });
    } else if (e.target.name === "tele_number") {
      const regex = /^[0-9]+$/;
      if (regex.test(e.target.value)) {
        const newNum = formatNumber(e.target.value);
        setAllowanceFields({ ...allowanceFields, tele_number: newNum });
      } else {
        setAllowanceFields({ ...allowanceFields, tele_number: "" });
      }
    } else if (e.target.name === "allowance") {
      const parsedValue = (e.target.value).replace(/^0+(?!\.)/, "") || "0";
      const value = e.target.value;
       //const regex = /^\d*(\.\d{0,2})?$/;
       
       const regex = /^[0-9]*\.?[0-9]{0,2}$/;

        if (regex.test(value)) {
         setAllowanceFields({ ...allowanceFields, allowance: value });
        }
       //setAllowanceHeight("95px");
       if (parsedValue !== "0" && parsedValue !== "0.0" && parsedValue !== "0.00") {
         setFormErrors({ ...formErrors, err_allowance: false, allowance: "" });
       }
    } else {
      setAllowanceFields({
        ...allowanceFields,
        [e.target.name]: e.target.value,
      });
      if (e.target.name === "firstName") {
        setFormErrors({ ...formErrors, err_firstName: false, firstName: "" });
      }
      if (e.target.name === "lastName") {
        setFormErrors({ ...formErrors, err_lastName: false, lastName: "" });
      }
      if (e.target.name === "SSN") {
        setFormErrors({ ...formErrors, err_SSN: false, SSN: "" });
      }
      if (e.target.name === "allowance") {
        setFormErrors({ ...formErrors, err_allowance: false, allowance: "" });
      }
    }
  };

  const handlesearchmodalclose = () => {
    setsearchmodalOpen(false);
  };

  const handlesearchmodalOpen = () => {
    setsearchmodalOpen(true);
  };

  const handlemodalclose = () => {
    setAllowanceModalOpen(false);
  };

  const validateFormFields = () => {
    var error = false;
    if (
      allowanceFields.firstName === "" ||
      allowanceFields.firstName === undefined
    ) {
      setFormErrors((formErrors) => ({
        ...formErrors,
        firstName: "First Name field can't be blank",
        err_firstName: true,
      }));
      setRowHeight("120px");
      error = true;
      return error;
    }
    if (
      allowanceFields.lastName === "" ||
      allowanceFields.lastName === undefined
    ) {
      setFormErrors((formErrors) => ({
        ...formErrors,
        lastName: "Last Name can't be blank",
        err_lastName: true,
      }));
      setRowHeight("120px");
      error = true;
      return error;
    }
    if (allowanceFields.SSN === "" || allowanceFields.SSN === undefined) {
      setFormErrors((formErrors) => ({
        ...formErrors,
        SSN: "SSN can't be blank",
        err_SSN: true,
      }));
      setSSNHeight("120px");
      error = true;
      return error;
    }
    if (
      allowanceFields.SSN !== "" &&
      allowanceFields.SSN !== undefined &&
      allowanceFields.SSN.length < 9
    ) {
      
      setFormErrors((formErrors) => ({
        ...formErrors,
        SSN: "SSN should be a 9 digits numeric",
        err_SSN: true,
      }));
      setSSNHeight("120px");
      error = true;
      return error;
    }
    if (
      allowanceFields.allowance === "" ||
      allowanceFields.allowance === undefined ||
      allowanceFields.allowance === null
    ) {
      setFormErrors((formErrors) => ({
        ...formErrors,
        allowance: "Allowance field can't be blank",
        err_allowance: true,
      }));
      setAllowanceHeight("130px");
      error = true;
      return error;
    }
    
    const value = (allowanceFields.allowance).replace(/^0+(?!\.)/, "") || "0" ;
    if(value && (value === "0" || value === "0.0" || value === "0.00" || value === "0.")
    ){
      setFormErrors((formErrors) => ({
        ...formErrors, 
        err_allowance: true, 
        allowance: "Please enter an allowance greater than 0" 
      }));
      setAllowanceHeight("130px");
      error = true;
      return error;
    }
    else{
      error = false;
      return error;
    }
    //return error;
  };

  const handleOpen = () => {
    let error = validateFormFields();
    if (!error) {
      setAllowanceModalOpen(true);
    }
  };

  function handlesnackbardata(data) {
    setsnackbardata(data);
  }

  const handleclose = (event) => {
    setOpen(false);
  };

  function handleindicatordata(data) {
    setindicatordata(data);
  }

  const handleClickShowSSN = () => {
    setShowSSN(!showSSN);
  };

  const handleOnBlur = (e) => {
    if (!e.target.value.trim()) {
      setFocus(false);
    }
  };

  let k = "";
  let p = "";
  let r = "";
  let s = "";
  let y = "";
  const formatDate = (date) => {
    k = date.getMonth() + 1;
    if (date.getMonth() + 1 < 10) {
      p = date.getMonth() + 1;
      k = "0" + p;
    }
    s = date.getDate();
    if (date.getDate() < 10) {
      r = date.getDate();
      s = "0" + r;
    }
    y = date.getFullYear();
    var finalDate = k + "/" + s + "/" + y;
    setAllowanceFields({
      ...allowanceFields,
      allowance_date: finalDate,
      picker_date: finalDate,
    });
  };

  const dateHandler = (e) => {
    var date = new Date(e.$d);
    formatDate(date);
  };

  const getDefaultDate = (date) => {
    var newDate = date ? new Date(date) : new Date();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");
    const year = newDate.getFullYear();
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  };

  const populateData = (rowdata) => {
    let echEDate;
    if (rowdata.achEDate != null) {
      echEDate = rowdata.achEDate;
    }
    const masked_ssn = maskSSNNumber(rowdata.ssn);

    setAllowanceFields((allowanceFields) => ({
      ...allowanceFields,
      firstName: rowdata.payeeFirstName,
      lastName: rowdata.payeeLastName,
      mask_ssn: masked_ssn,
      SSN: rowdata.ssn,
      //allowance: rowdata.allowanceUpdate,
      picker_date: echEDate
        ? echEDate
        : getDefaultDate(allowanceFields.picker_date),
      allowance_date: echEDate,
      id: rowdata.id,
      enrollmentId: rowdata.enrollmentId
    }));

    if (rowdata.payeeFirstName !== "") {
      setFormErrors((formErrors) => ({
        ...formErrors,
        firstName: "",
        err_firstName: false,
      }));
      setRowHeight("65px");
    }
    if (rowdata.payeeLastName !== "") {
      setFormErrors((formErrors) => ({
        ...formErrors,
        lastName: "",
        err_lastName: false,
      }));
      setRowHeight("65px");
    }
    if (rowdata.ssn !== "") {
      setFormErrors((formErrors) => ({
        ...formErrors,
        SSN: "",
        err_SSN: false,
      }));
      setSSNHeight("65px");
    }
    if (rowdata.allowance !== "") {
      setFormErrors((formErrors) => ({
        ...formErrors,
        allowance: "",
        err_allowance: false,
      }));
      setSSNHeight("65px");
    }
  };

  const resetForm = () => {
    setAllowanceFields({
      firstName: "",
      lastName: "",
      tele_number: carefacilitydetails.phone,
      contact: carefacilitydetails.contactPerson,
      mask_accNum: maskedAccountId(carefacilitydetails.accountNumber),
      accountNum: carefacilitydetails.accountNumber,
      address: {
        street: carefacilitydetails.address,
        city: carefacilitydetails.city,
        state: carefacilitydetails.state,
        zip_code: carefacilitydetails.zip,
      },
      SSN: "",
      mask_ssn: "",
      allowance: "",
    });
  };

  const handleClose = () => {
    setModalOpen(false);
    navigate("/allowanceListings");
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          left: "25%",
          flexDirection: "column",
          width: "50%",
          marginTop: "20px",
          alignItems: "center",
          p: "0% 2%",
          backgroundColor: "#fcfcfc",
          border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
        <h2 className="header">Allowance Update Form</h2>
        <Divider
          variant="fullwidth"
          sx={{ backgroundColor: "#dfe3e8" }}
        ></Divider>
        <br></br>
        <Grid>
          <Grid
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${nameRowHeight}`, m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">
                  First Name <span id="note">*</span>
                </p>
                <TextField
                  sx={{ paddisngRight: "0 !important", width: "190px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment id="tf">
                        <IconButton
                          id="searchicon"
                          onClick={handlesearchmodalOpen}
                          sx={{ padding: "0 !important", boxShadow: "none" }}
                        >
                          <PersonSearchIcon id="searchicon" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    readOnly: true,
                    onClick: handlesearchmodalOpen,
                  }}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="First Name"
                  value={allowanceFields.firstName || ""}
                  name="firstName"
                  helperText={formErrors.firstName ? formErrors.firstName : ""}
                  error={formErrors.err_firstName}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">
                  Last Name <span id="note">*</span>
                </p>
                <TextField
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="Last Name"
                  value={allowanceFields.lastName || ""}
                  name="lastName"
                  sx={{ width: "210px" }}
                  helperText={formErrors.lastName ? formErrors.lastName : ""}
                  error={formErrors.err_lastName}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${ssnRowHeight}`, m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">
                  SSN <span id="note">*</span>
                </p>
                {/* <TextField
                  type={showSSN ? "text" : "password"}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="SSN"
                  value={allowanceFields.SSN}
                  //title={allowanceFields.SSN}
                  name="SSN"
                  sx={{ width: "190px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowSSN}
                          edge="end"
                        >
                          {showSSN ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{ readOnly: true, maxLength: 9 }}
                  onFocus={() => setFocus(true)}
                  onBlur={handleOnBlur}
                  helperText={formErrors.SSN ? formErrors.SSN : ""}
                  error={formErrors.err_SSN}
                ></TextField> */}
                <SSNTextField
                  name="SSN"
                  onChange={inputHandler}
                  value={allowanceFields.SSN}
                  showSSN={showSSN}
                  setFocus={setFocus}
                  handleOnBlur={handleOnBlur}
                  handleClickShowSSN={handleClickShowSSN}
                  formErrors={formErrors}
                  editable="No"
                />
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label-date">
                  Date <span id="note">*</span>
                </p>
                <DatePicker
                  sx={{ marginLeft: "50px !important" }}
                  inputFormat="MM DD YYYY"
                  onChange={dateHandler}
                  value={dayjs(allowanceFields.picker_date)}
                  default={dayjs(allowanceFields.picker_date)}
                ></DatePicker>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
             <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${allowanceHeight}`, m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">
                  Allowance <span id="note">*</span>
                </p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  name="allowance"
                  value={allowanceFields.allowance}
                  placeholder=""
                  onChange={inputHandler}
                  sx={{ width: "190px" }}
                  inputProps={{inputMode:'decimal', maxLength: 22, step: 1 }}
                  helperText={formErrors.allowance ? formErrors.allowance : ""}
                  error={formErrors.err_allowance}
                >
                </TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
              </Box>
            </Stack>            
          </Grid>

          <br></br>

          <Grid
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", mb: "5px" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">Point Of Contact</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="Contact"
                  value={allowanceFields.contact}
                  name="Contact"
                  onChange={inputHandler}
                  sx={{ width: "190px", marginLeft: "4px" }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">Account No.</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="XXXXXXXX1234"
                  value={allowanceFields.mask_accNum}
                  name="accountNum"
                  onChange={inputHandler}
                  sx={{ width: "190px" }}
                  title={allowanceFields.accountNum}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              sx={{ width: "100%", height: "150px" }}
            >
              <p className="input-label">Address </p>
              <Box
                display="grid"
                sx={{
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gridTemplateRows: "auto",
                  gridTemplateAreas: `"street street street" "city state zip"`,
                  columnGap: 2,
                  rowGap: 1,
                  ml: "12px",
                }}
              >
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="Street"
                  value={allowanceFields.address.street}
                  name="add_street"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "street" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="City"
                  value={allowanceFields.address.city}
                  name="add_city"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "city" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true, maxLength: 2 }}
                  variant="outlined"
                  placeholder="State"
                  value={allowanceFields.address.state}
                  name="add_state"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "state" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true, maxLength: 6 }}
                  variant="outlined"
                  type="number"
                  placeholder="Zip Code"
                  value={allowanceFields.address.zip_code}
                  name="add_code"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "zip" }}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">Telephone No </p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true, maxLength: 12 }}
                  variant="outlined"
                  margin="none"
                  placeholder="Telephone"
                  value={allowanceFields.tele_number || ""}
                  name="tele_number"
                  onChange={inputHandler}
                  sx={{ width: "190px", marginLeft: "4px" }}
                ></TextField>
              </Box>
            </Stack>
          </Grid>
          <br></br>
          <p id="note">
            Note : Fields marked as * are mandatory to be entered...!
          </p>
          <Grid
            item
            xs={12}
            sx={{
              mt: "5px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              sx={{ width: "350px", justifyContent: "space-between" }}
            >
              {location && location.state && location.state.routeName &&
                location.state.routeName != "" ?
              <BackButton
                variant="outlined"
                sx={{ width: "140px", height: "40px", margin: "5px" }}
                onClick={() => {
                  navigate("/allowanceListings");
                }}
              >
                Back
              </BackButton>
              :
              <BackButton
                variant="outlined"
                sx={{ width: "140px", height: "40px", margin: "5px" }}
                onClick={() => {
                  navigate("/home");
                }}
              >
                Back
              </BackButton>
              }
              <ResetButton
                variant="outlined"
                sx={{ width: "140px", height: "40px", margin: "5px" }}
                onClick={resetForm}
              >
                Reset
              </ResetButton>
            </Box>
            <Box>
              <Button onClick={handleOpen} id="btn1" variant="contained">
                Submit
              </Button>
            </Box>
          </Grid>

          {/*below one is Allowance user search modal */}
          {searchmodalopen && (
            <SearchAllowanceModal
              getData={populateData}
              open={searchmodalopen}
              plzclose={handlesearchmodalclose}
              errorFlag={errorFlag}
              setErrorFlag={setErrorFlag}
              successFlag={successFlag}
              setSuccessFlag={setSuccessFlag}
              responseMsg={responseMsg}
              setResponseMsg={setResponseMsg}
              setMsgModalOpen={setMsgModalOpen}
              msgModalOpen={msgModalOpen}
            />
          )}

          {/*below one is Allowance verification modal */}
          {allowanceModalOpen && (
            <AllowanceModal
              allowanceModalOpen={allowanceModalOpen}
              setAllowanceModalOpen={setAllowanceModalOpen}
              plzclose={handlemodalclose}
              requestsnackbardata={handlesnackbardata}
              requestindicatordata={handleindicatordata}
              allowanceFields={allowanceFields}
              setShowMsg={setShowMsg}
              setErrorMsg={setErrorMsg}
              setResponseMsg={setResponseMsg}
              setErrorFlag={setErrorFlag}
              setMsgModalOpen={setMsgModalOpen}
              successFlag={successFlag} 
              setSuccessFlag={setSuccessFlag}
              errorFlag={errorFlag} 
              msgModalOpen={msgModalOpen}
              setSuccess={setSuccess}
              setModalOpen={setModalOpen}
            />
          )}
          {indicatordata && (
            <>
              <Backdrop
                sx={{
                  color: "white",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={true}
              >
                <CircularProgress sx={{ color: "white" }} />
                <span> &nbsp;&nbsp;&nbsp;&nbsp; Submitting... </span>
              </Backdrop>
            </>
          )}
          {/*<Fade in={snackbardata} timeout={{ enter: 100, exit: 2500 }}>
             <Snackbar
              open={showMsg}
              onClose={handleclose}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
            >
              <Alert
                severity={errorMsg ? "error" : "success"}
                sx={{ width: "100%" }}
              >
                {errorMsg ? errorMsg : "Form Submitted successfully..!"}
              </Alert>
            </Snackbar> 
          </Fade>*/}
          <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <>
            {success && (
              <Box sx={style}>
                <IconButton
                  sx={{ border: "2px solid green", boxShadow: "none" }}
                >
                  <Check sx={{ color: "green" }} />
                </IconButton>
                <p>
                  One Time Allowance created successfully!
                </p>
                <Button
                  id="modal-close-btn"
                  variant="contained"
                  onClick={handleClose}
                >
                  Close
                </Button>
              </Box>
            )}
          </>
        </Modal>
          <br></br>
        </Grid>
      </Box>
    </>
  );
}
